import { render, staticRenderFns } from "./CystsTable.vue?vue&type=template&id=0c2a3a52&"
import script from "./CystsTable.vue?vue&type=script&lang=js&"
export * from "./CystsTable.vue?vue&type=script&lang=js&"
import style0 from "./CystsTable.vue?vue&type=style&index=0&id=0c2a3a52&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports